// extracted by mini-css-extract-plugin
module.exports = {"error":"VContact_error_1AUeW"};